import FJLocalStore from '../../../store/FJLocalStore';
import FJCheckBox from '../FJCheckBox/FJCheckBox';
import styles from './FJSideModelSelectedInputBox.module.less';
import classNames from 'classnames';
import ArrowIcon from '../../../assets/svg/button-right-2.svg?react';
import FJSideModel from '../FJSideModel/FJSideModel';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../store/FJEvent';

const FJSideModelSelectedInputBox = props => {
    const {
        isShowCheckBox,
        isShowArrowIcon,

        selectedName,
        title,
        checkBoxText,
        className,
        modelPosition = { top: 125, left: 478 },

        imgUrl,
        isShowImg = false,

        titleTextClassName,

        color,
        isShowColor = false,

        checked,

        checkBoxChange,
        showModelCallback,
        hideModelCallback,

        children,
    } = props;

    const [modelActive, setModelActive] = useState(false);

    useEffect(() => {
        if (modelActive) {
            showModelCallback && showModelCallback();
        } else {
            hideModelCallback && hideModelCallback();
        }
    }, [modelActive]);

    const handleOnMouseDown = e => {
        modelActive && e.stopPropagation();
    };

    const handleClick = e => {
        e.stopPropagation();
        if (!modelActive) {
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        }
        setModelActive(!modelActive);
    };

    return (
        <>
            <div className={classNames(styles.box, className)}>
                <div className={styles.title}>
                    <div className={classNames(styles.title_text, titleTextClassName)}>{FJLocalStore._(title)}</div>
                    {isShowCheckBox && (
                        <FJCheckBox
                            className={styles.apply_to_all_checkbox}
                            iconClassName={classNames(styles.apply_to_all_icon, {
                                [styles.apply_to_all_icon_checked]: checked,
                            })}
                            textClassName={styles.apply_to_all_text}
                            value={FJLocalStore._(checkBoxText)}
                            dataChange={checkBoxChange}
                            selected={checked}
                        />
                    )}
                </div>
                <div className={styles.btu} onClick={handleClick} onMouseDown={handleOnMouseDown}>
                    {isShowImg && (
                        <div className={styles.img_box}>
                            <img src={imgUrl} loading='lazy' />
                        </div>
                    )}
                    {isShowColor && <div className={styles.color_box} style={{ backgroundColor: color }}></div>}
                    <div className={styles.name}>{FJLocalStore._(selectedName)}</div>
                    {isShowArrowIcon && <ArrowIcon className={styles.arrow_icon} />}
                </div>
            </div>

            <FJSideModel
                position={modelPosition}
                active={modelActive}
                className={styles.side_model}
                onClose={() => setModelActive(false)}
            >
                {children}
            </FJSideModel>
        </>
    );
};

FJSideModelSelectedInputBox.propTypes = {
    className: PropTypes.string,
};

export default FJSideModelSelectedInputBox;
